// Stars

// ___________________________________________________________________

import * as React from 'react'
import theme from '../../gatsby-plugin-theme-ui'

// ___________________________________________________________________

const Stars = () => (
  <svg viewBox="0 0 219.49 41.15">
    <title>Star rating</title>
    <path
      fill={theme.colors.goldenrod}
      d="M43.3,15.7q-3.13,2.36-12.93,9.88c.55,1.73,1.36,4.34,2.42,7.81l2.37,7.76L21.74,31.94q.12,0-13.35,9.21Q13,26.06,13,25.69s-4.34-3.33-13-9.9l14.84-.37,1.44,0Q17.93,10.68,21.61,0,24.84,9,27,15.29a7,7,0,0,0,.94.16Q33.64,15.5,43.3,15.7Z"
    />
    <path
      fill={theme.colors.goldenrod}
      d="M87.35,15.7q-3.13,2.36-12.93,9.88c.55,1.73,1.35,4.34,2.42,7.81s1.85,6,2.37,7.76L65.78,31.94q.12,0-13.34,9.21,4.62-15.09,4.62-15.46s-4.33-3.33-13-9.9l14.83-.37,1.45,0Q62,10.68,65.66,0q3.23,9,5.41,15.29a7.18,7.18,0,0,0,1,.16C75.8,15.48,80.9,15.56,87.35,15.7Z"
    />
    <path
      fill={theme.colors.goldenrod}
      d="M131.4,15.7q-3.15,2.36-12.94,9.88c.56,1.73,1.36,4.34,2.42,7.81s1.85,6,2.38,7.76l-13.43-9.21q.12,0-13.35,9.21,4.63-15.09,4.63-15.46s-4.34-3.33-13-9.9l14.84-.37,1.44,0Q106,10.68,109.7,0q3.22,9,5.42,15.29a7.18,7.18,0,0,0,.95.16Q121.73,15.5,131.4,15.7Z"
    />
    <path
      fill={theme.colors.goldenrod}
      d="M175.44,15.7q-3.13,2.36-12.93,9.88c.55,1.73,1.36,4.34,2.42,7.81l2.37,7.76-13.42-9.21q.12,0-13.35,9.21,4.62-15.09,4.63-15.46s-4.34-3.33-13-9.9L147,15.42l1.44,0q1.65-4.7,5.33-15.38,3.23,9,5.41,15.29a7.51,7.51,0,0,0,1,.16Q165.78,15.5,175.44,15.7Z"
    />
    <path
      fill={theme.colors.goldenrod}
      d="M219.49,15.7q-3.15,2.36-12.93,9.88c.55,1.73,1.35,4.34,2.41,7.81s1.86,6,2.38,7.76l-13.43-9.21q.12,0-13.34,9.21,4.62-15.09,4.62-15.46s-4.34-3.33-13-9.9L191,15.42l1.45,0q1.65-4.7,5.33-15.38,3.22,9,5.41,15.29a7.18,7.18,0,0,0,.95.16C207.94,15.48,213,15.56,219.49,15.7Z"
    />
  </svg>
)

export default Stars

